import React from "react";
import Social from "./Social";

const Home = () => {
  return (
    <>
      <div className="tokyo_tm_home">
        <div className="home_content">

          <div className="avatar">

            <div
              className="image avatar_img"
              style={{
                backgroundImage: "url(assets/img/slider/face.jpeg)",
              }}
            >

            </div>
            
          </div>

          <div className="details">

            <h3 className="name">Javier Villanueva</h3>

            <p className="job">
              Fronted Devloper based in México and happy to develop solutions for all kind of people
            </p>
            

            <Social />
            
          </div>

        </div>
        {/* END HOME CONTENT */}
      </div>
      {/* END HOME */}
    </>
  );
};

export default Home;
